@if (buttons && buttons.length > 0) {
  <div class="transition" style="position:relative; pointer-events: none;"
    [ngStyle]="{'position': 'absolute', 'top': positionObject.top, 'left': positionObject.left, 'right': positionObject.right, 'bottom': positionObject.bottom }">
    <!-- DrawFinishedButtons -->
    @if (buttonService.drawfinished) {
      @for (button of buttonService.onDrawFinishedButtons; track button; let i = $index) {
        <!-- meerdere mat icons om icons te mergen in 1-->
        @if (buttonService.onDrawFinishedButtons.length !== i+1) {
          <button matTooltip="{{ button.tooltip | translate }}" #tooltip="matTooltip" mat-mini-fab color="primary" style="margin-left: 3px; margin-right: 3px; pointer-events: auto;" (click)="buttonService.onDrawFinishMethods(button)">
            @if (button.icon === 'delete') {
              <mat-icon style="font-size: 18px; position: absolute; bottom: 3px; right: -2px;">
                edit
              </mat-icon>
            }
            @if (button.icon === 'delete') {
              <mat-icon style="position: absolute; left: 4px; bottom: 7px;">
                {{button.icon}}
              </mat-icon>
            }
            @if (button.icon !== 'delete') {
              <mat-icon>
                {{button.icon}}
              </mat-icon>
            }
          </button>
        }
        @if (buttonService.onDrawFinishedButtons.length === i+1) {
          <button matTooltip="{{ button.tooltip | translate }}" #tooltip="matTooltip" mat-mini-fab color="primary" style="margin-right: 10px; margin-left: 3px; pointer-events: auto;" (click)="buttonService.onDrawFinishMethods(button)">
            @if (button.icon === 'delete') {
              <mat-icon style="font-size: 18px; position: absolute; bottom: 3px; right: -2px;">
                edit
              </mat-icon>
            }
            @if (button.icon === 'delete') {
              <mat-icon style="position: absolute; left: 4px; bottom: 7px;">
                {{button.icon}}
              </mat-icon>
            }
            @if (button.icon !== 'delete') {
              <mat-icon>
                {{button.icon}}
              </mat-icon>
            }
          </button>
        }
        @if (buttonService.onDrawFinishedButtons.length === i+1) {
          <div style="height: 36px; width: 4px; background-color: white; display: inline-block; position: absolute; top: 5px; left: 232px; border-radius: 95%;">
          </div>
        }
      }
    }
    <!-- KLIC SNIJD DRAW FINISHED-->
    @if (buttonService.klicDrawFinished) {
      @for (button of buttonService.OnDrawFinishedKlicFeature; track button; let i = $index) {
        <button matTooltip="{{ button.tooltip | translate }}" #tooltip="matTooltip" mat-mini-fab color="primary" style="margin-right: 10px; margin-left: 3px; pointer-events: auto;" (click)="buttonService.onDrawFinishMethods(button)">
          <mat-icon>
            done
          </mat-icon>
        </button>
      }
    }
    <!--
    <ng-container *ngIf="buttonService.measurefinished">
      <ng-container *ngFor="let button of buttonService.onMeasureFinishedButtons">
        <button mat-mini-fab color="primary" style="margin: 3px;" (click)="buttonService.onDrawFinishMethods(button)">
          <mat-icon style="position: absolute; bottom: 6px; right: -2px;">
            square_foot
          </mat-icon>
          <mat-icon style="position: absolute; left: 4px; bottom: 7px;">
            {{button.icon}}
          </mat-icon>
        </button>
      </ng-container>
    </ng-container>
    -->
    @for (button of buttons; track button) {
      @if (!button.children) {
        <button [matTooltip]="button.tooltop" #tooltip="matTooltip" (click)="buttonService.buttonCreateMyComponent(button, false);" [ngClass]="button == activeButton ? 'activebutton' : ''" color="primary" mat-mini-fab style="margin-left: 3px; margin-right: 3px; pointer-events: auto;">
          <ng-container>
            <mat-icon>
              {{button.icon}}
            </mat-icon>
          </ng-container>
        </button>
      }
      @if (button.children) {
        <app-expandablebutton matTooltip="{{ 'tooltip.open' | translate }}" #tooltip="matTooltip" style="margin-left: 3px; margin-right: 3px; pointer-events: auto;" [expandTo]="'bottom'" [button]="button"></app-expandablebutton>
      }
    }
    <button matTooltip="{{ 'tooltip.cancel' | translate }}" (click)="buttonService.putMapInteractionOff();" mat-mini-fab color="primary" style="margin-left: 3px; margin-right: 3px; pointer-events: auto;">
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>
}